/* White landing: typing headline, auto + drag reels, UGC autoplay, lightbox, bundle total, sticky bar, reveal. */
(function () {
  if (window.__wlInit) return;
  window.__wlInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* Typing headline */
  function typeHead() {
    document.querySelectorAll('[data-wl-type]').forEach(function (h1) {
      if (reduce) return;
      var lines = h1.querySelectorAll('[data-text]'), delay = 60;
      lines.forEach(function (line) {
        var text = line.getAttribute('data-text') || '';
        line.textContent = '';
        setTimeout(function () {
          var i = 0;
          (function step() { line.textContent += text.charAt(i); i++; if (i < text.length) setTimeout(step, 18); })();
        }, delay);
        delay += text.length * 18 + 140;
      });
    });
  }

  /* Mouse drag for reels (touch scrolls natively) */
  function draggable(el) {
    var down = false, startX = 0, start = 0, moved = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = 0; startX = e.clientX; start = el.scrollLeft; el.classList.add('is-dragging');
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX; moved = Math.max(moved, Math.abs(dx)); el.scrollLeft = start - dx;
    });
    function end() { down = false; el.classList.remove('is-dragging'); }
    el.addEventListener('pointerup', end); el.addEventListener('pointerleave', end);
    el.addEventListener('click', function (e) { if (moved > 6) { e.stopPropagation(); e.preventDefault(); } }, true);
  }

  /* Auto-advance a reel horizontally (never scrolls the page) */
  function autoAdvance(reel, interval, center) {
    var items = Array.prototype.slice.call(reel.children);
    if (items.length < 2) return;
    var idx = 0, paused = false, visible = false;
    function mark() {
      if (!center) return;
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === idx); });
    }
    function go(i) {
      idx = (i + items.length) % items.length;
      var it = items[idx], r = reel.getBoundingClientRect(), b = it.getBoundingClientRect(), pad = 16, delta;
      if (center) delta = (b.left + b.width / 2) - (r.left + r.width / 2);
      else delta = (b.right - r.right) + pad; /* RTL: start edge is on the right */
      reel.scrollBy({ left: delta, behavior: 'smooth' });
      mark();
    }
    mark();
    setInterval(function () { if (!paused && visible && !document.hidden) go(idx + 1); }, interval);
    function pause() { paused = true; clearTimeout(reel.__wlT); reel.__wlT = setTimeout(function () { paused = false; }, 6000); }
    reel.addEventListener('pointerdown', pause);
    reel.addEventListener('touchstart', pause, { passive: true });
    reel.addEventListener('wheel', pause, { passive: true });
    if (center) {
      /* keep the active card in sync when the user swipes */
      var t;
      reel.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var r = reel.getBoundingClientRect(), mid = r.left + r.width / 2, best = 0, bd = 1e9;
          items.forEach(function (it, i) { var b = it.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - mid); if (d < bd) { bd = d; best = i; } });
          if (best !== idx) { idx = best; mark(); }
        }, 120);
      }, { passive: true });
    }
    if (hasIO) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(reel);
    else visible = true;
  }


  /* Whitening simulator: before -> after teeth colour, shade marker, toner shine, course length */
  var AR = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
  function ar(n) { return String(n).replace(/[0-9]/g, function (d) { return AR[+d]; }); }
  function mix(a, b, t) {
    var pa = [1,3,5].map(function (k) { return parseInt(a.substr(k, 2), 16); });
    var pb = [1,3,5].map(function (k) { return parseInt(b.substr(k, 2), 16); });
    return 'rgb(' + pa.map(function (v, k) { return Math.round(v + (pb[k] - v) * t); }).join(',') + ')';
  }
  var BEFORE = '#E4D08F', WHITE = '#FBF8EF';
  function simLevel(sim, p) {
    var c = sim.__cfg; if (!c) return;
    p = Math.max(0, Math.min(1, p)); sim.__p = p;
    var target = mix(BEFORE, WHITE, Math.min(c.shades / 4, 1));
    var a = [1,3,5].map(function (k) { return parseInt(BEFORE.substr(k, 2), 16); });
    var b = target.match(/\d+/g).map(Number);
    sim.style.setProperty('--wl-tooth', 'rgb(' + a.map(function (v, k) { return Math.round(v + (b[k] - v) * p); }).join(',') + ')');
    var dot = sim.querySelector('[data-wl-shade-dot]'), bub = sim.querySelector('[data-wl-shade-bubble]');
    if (dot) dot.style.setProperty('--wl-dot', Math.min(0.5 + p * c.shades * 1.6, 7.5));
    if (bub) { var n = Math.round(p * c.shades); bub.textContent = n ? '+' + ar(n) + ' درجات' : 'الحين'; }
    var rng = sim.querySelector('[data-wl-shade-range]'); if (rng && !sim.__drag) rng.value = Math.round(p * 100);
    var done = p >= 0.97;
    sim.classList.toggle('has-shine', done && c.shine);
    sim.classList.toggle('has-shine-max', done && c.max);
    sim.classList.toggle('is-done', done);
  }
  function simAnimate(sim, from, to, ms) {
    cancelAnimationFrame(sim.__raf);
    if (reduce) { simLevel(sim, to); return; }
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min((ts - t0) / ms, 1), e = 1 - Math.pow(1 - k, 3);
      simLevel(sim, from + (to - from) * e);
      if (k < 1) sim.__raf = requestAnimationFrame(step);
    }
    sim.__raf = requestAnimationFrame(step);
  }
  function simUpdate(form, input) {
    var sim = form.querySelector('[data-wl-sim]');
    if (!sim) return;
    sim.__cfg = {
      shades: parseFloat(input.getAttribute('data-shades')) || 0,
      shine: input.getAttribute('data-shine') === '1',
      max: input.getAttribute('data-shine-max') === '1'
    };
    if (!sim.__wired) {
      sim.__wired = true;
      var shade = sim.querySelector('.wl-shade.is-slider'), hint = sim.querySelector('[data-wl-shade-hint]');
      if (shade) {
        var track = shade.querySelector('.wl-shade-track'), bar = shade.querySelector('.wl-shades-bar');
        var at = function (x) { var r = bar.getBoundingClientRect(); return (r.right - x) / r.width; }; /* RTL: right = now, left = white */
        var down = false;
        track.addEventListener('pointerdown', function (ev) {
          down = true; sim.__drag = true; cancelAnimationFrame(sim.__raf); clearTimeout(sim.__t);
          if (hint) hint.classList.add('is-used');
          try { track.setPointerCapture(ev.pointerId); } catch (err) {}
          simLevel(sim, at(ev.clientX)); ev.preventDefault();
        });
        track.addEventListener('pointermove', function (ev) { if (down) simLevel(sim, at(ev.clientX)); });
        var up = function () { down = false; sim.__drag = false; };
        track.addEventListener('pointerup', up); track.addEventListener('pointercancel', up);
        var rng = shade.querySelector('[data-wl-shade-range]');
        if (rng) rng.addEventListener('input', function () { cancelAnimationFrame(sim.__raf); simLevel(sim, rng.value / 100); });
      }
    }
    simLevel(sim, 0);
    clearTimeout(sim.__t);
    sim.__t = setTimeout(function () { simAnimate(sim, 0, 1, 1500); }, reduce ? 0 : 300);
  }

  ready(function () {
    typeHead();

    document.querySelectorAll('.wl-reel').forEach(function (reel) {
      draggable(reel);
      if (reduce) return;
      if (reel.hasAttribute('data-wl-center')) return; /* UGC reels handled below */
      autoAdvance(reel, parseInt(reel.getAttribute('data-wl-interval') || '3000', 10), false);
    });

    /* UGC videos: tap any card = it moves to the centre and plays with sound.
       Otherwise the centre card plays muted and the reel advances on its own. */
    document.querySelectorAll('.wl-ugc .wl-reel').forEach(function (reel) {
      var cards = Array.prototype.slice.call(reel.querySelectorAll('.wl-ugc-card'));
      if (!cards.length) return;
      var idx = 0, soundOn = false, visible = !hasIO, userHold = 0;
      function vid(i) { return cards[i].querySelector('video'); }
      function centre(i) {
        var r = reel.getBoundingClientRect(), b = cards[i].getBoundingClientRect();
        reel.scrollBy({ left: (b.left + b.width / 2) - (r.left + r.width / 2), behavior: 'smooth' });
      }
      function activate(i, withSound) {
        idx = (i + cards.length) % cards.length;
        cards.forEach(function (c, k) {
          c.classList.toggle('is-active', k === idx);
          var v = vid(k), m = c.querySelector('.wl-ugc-media');
          if (k !== idx && v) { v.pause(); v.muted = true; v.controls = false; m.classList.remove('is-playing'); }
        });
        centre(idx);
        var v = vid(idx), m = cards[idx].querySelector('.wl-ugc-media');
        if (!v) return;
        if (v.preload === 'none') v.preload = 'metadata';
        m.classList.remove('is-paused');
        if (withSound) {
          soundOn = true;
          v.muted = false; v.loop = false; v.controls = false;
          try { v.currentTime = 0; } catch (err) {}
          m.classList.add('is-playing');
        } else if (!reduce && visible) {
          v.muted = true; v.loop = true; v.controls = false;
        } else { return; }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      cards.forEach(function (c, k) {
        c.addEventListener('click', function (e) {
          var v = vid(k), m = c.querySelector('.wl-ugc-media');
          e.preventDefault();
          /* tap the video that is playing with sound = pause; tap again = resume from the same spot */
          if (soundOn && k === idx && v) {
            userHold = Date.now();
            if (v.paused) { m.classList.remove('is-paused'); m.classList.add('is-playing'); var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
            else { v.pause(); m.classList.remove('is-playing'); m.classList.add('is-paused'); }
            return;
          }
          activate(k, true);
        });
        var v = vid(k);
        if (v) v.addEventListener('ended', function () {
          if (k !== idx) return;
          soundOn = false; v.controls = false;
          c.querySelector('.wl-ugc-media').classList.remove('is-playing', 'is-paused');
          activate(k + 1, false);
        });
      });
      reel.addEventListener('touchstart', function () { userHold = Date.now(); }, { passive: true });
      reel.addEventListener('pointerdown', function () { userHold = Date.now(); });
      /* after a manual swipe, the card nearest the centre becomes active */
      var st;
      reel.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var cv = vid(idx);
          if (soundOn && cv && !cv.paused) return;
          var r = reel.getBoundingClientRect(), mid = r.left + r.width / 2, best = idx, bd = 1e9;
          cards.forEach(function (c, k) { var b = c.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - mid); if (d < bd) { bd = d; best = k; } });
          if (best !== idx && Date.now() - userHold < 3000) { soundOn = false; activate(best, false); }
        }, 150);
      }, { passive: true });
      if (hasIO) new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        var v = vid(idx);
        if (!visible && v) { v.pause(); if (soundOn) { soundOn = false; v.controls = false; cards[idx].querySelector('.wl-ugc-media').classList.remove('is-playing', 'is-paused'); } }
        else if (visible && !soundOn) activate(idx, false);
      }, { threshold: 0.35 }).observe(reel);
      cards[0].classList.add('is-active');
      var every = parseInt(reel.getAttribute('data-wl-interval') || '4200', 10);
      if (!reduce) setInterval(function () {
        if (soundOn || !visible || document.hidden || Date.now() - userHold < 6000) return;
        activate(idx + 1, false);
      }, every);
    });

    /* Lightbox + video tap */
    var lb = document.createElement('div');
    lb.className = 'wl wl-lb'; lb.hidden = true; lb.innerHTML = '<img alt="">';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('img');
    document.addEventListener('click', function (e) {
      var shot = e.target.closest('.wl-shot');
      if (shot) {
        var im = shot.querySelector('img'); if (!im) return;
        lbImg.src = shot.getAttribute('data-full') || im.currentSrc || im.src; lbImg.alt = im.alt; lb.hidden = false; return;
      }
      if (e.target.closest('.wl-lb')) { lb.hidden = true; return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.hidden = true; });

    /* Bundle choice -> total + sticky */
    var sPrice = document.querySelector('[data-wl-sticky-price]');
    var sLabel = document.querySelector('[data-wl-sticky-label]');
    document.querySelectorAll('[data-wl-form]').forEach(function (form) {
      var total = form.querySelector('[data-wl-total]');
      var sync = function () {
        var i = form.querySelector('input[name="id"]:checked'); if (!i) return;
        if (total) total.textContent = i.getAttribute('data-price');
        if (sPrice) sPrice.textContent = i.getAttribute('data-price');
        if (sLabel) sLabel.textContent = i.getAttribute('data-label');
        form.querySelectorAll('[data-wl-detail]').forEach(function (d) { d.hidden = d.getAttribute('data-wl-detail') !== i.value; });
        simUpdate(form, i);
      };
      form.addEventListener('change', sync); sync();
      form.addEventListener('click', function (e) {
        var up = e.target.closest('[data-wl-pick]');
        if (!up) return;
        e.preventDefault();
        var target = form.querySelector('input[name="id"][value="' + up.getAttribute('data-wl-pick') + '"]');
        if (target && !target.disabled) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
          var card = target.closest('.wl-bundle');
          if (card && card.animate) card.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.05)' }, { transform: 'scale(1)' }], { duration: 450 });
        }
      });
      var simEl = form.querySelector('[data-wl-sim]');
      if (simEl && hasIO) {
        var sio = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { sync(); sio.disconnect(); }
        }, { threshold: 0.4 });
        sio.observe(simEl);
      }
    });

    /* Reveal + step icons */
    var rv = document.querySelectorAll('.wl-rv, .wl-ico');
    if (!hasIO || reduce) rv.forEach(function (el) { el.classList.add('is-in'); });
    else {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
      }, { threshold: 0.3 });
      rv.forEach(function (el) { io.observe(el); });
    }

    /* Sticky bar: hidden until the visitor scrolls past the product photo, hidden again while the bundles are on screen */
    var sticky = document.querySelector('.wl-sticky');
    if (sticky) {
      var heroImg = document.querySelector('[data-wl-hero-img]') || document.querySelector('[data-wl-hero-cta]');
      var offer = document.querySelector('.wl-offer');
      var upd = function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var past = heroImg ? heroImg.getBoundingClientRect().bottom < 0 : true;
        var inOffer = false;
        if (offer) { var r = offer.getBoundingClientRect(); inOffer = r.top < vh * 0.85 && r.bottom > vh * 0.15; }
        sticky.classList.toggle('is-shown', past && !inOffer);
      };
      window.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
  });
})();
